import React from 'react'

import { MenuItem } from '@interco/inter-toranja'
import type { TagProps } from '@interco/inter-toranja/dist/types/shared'
import { useActionHandler } from '@/hooks/useActionHandler'
import { useHomeCreditListItemTag } from '@/hooks/useHomeCreditListItemTag'

import { Icon } from '../../Icons'
import Carousel from '../../Carousel'
import type { SDUIComponentProps } from '../interfaces'
import * as S from './styles'

const CarouselMenuItemRenderer: React.FC<{ component: SDUIComponentProps }> = ({ component }) => {
  const { dispatchAction } = useActionHandler()
  const fireListItemTag = useHomeCreditListItemTag()
  const items = (component?.props?.items ?? []) as CarouselMenuItem[]

  return (
    <S.ContainerCarouselMenu
      style={{
        marginTop: component.style?.marginTop,
        marginBottom: component.style?.marginBottom,
      }}
    >
      <Carousel gap={0} padding={16}>
        {items.map((item) => (
          <div key={item.id} style={{ width: '100%', marginTop: '8px' }}>
            <MenuItem
              variant="icon"
              icon={<Icon name={item.props.icon?.name ?? ''} />}
              tag={item.props.tag ?? undefined}
              size="large"
              label={item.props.title}
              onTag={(tag: TagProps) => fireListItemTag(tag, item.props.title)}
              onClick={() => dispatchAction(item.props.action, item.props.analytics)}
            />
          </div>
        ))}
      </Carousel>
    </S.ContainerCarouselMenu>
  )
}

export const CarouselMenuItem: React.FC<{ component: SDUIComponentProps }> =
  CarouselMenuItemRenderer
